<template>
  <div class="orderGroupDialog">
    <el-dialog
        :visible="visible"
        @close="handleClose"
        width="550px"
        top="350px"
        :title="$t('orderGroup.title')"
    >
      <div v-for="(item, i) in orderGroupList" :key="i">
        <span>{{$t("orderGroup.detail", [item.orderGroupTitle, item.orderIdList.join('，')])}}</span>
      </div>
      <span>{{$t("orderGroup.describe")}}</span>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleRemove">{{$t('orderGroup.remove')}}</el-button>
        <el-button size="mini" type="primary" @click="onSave">{{$t('orderGroup.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "orderGroupDialog",
  data(){
    return{
      form: {
        orderGroupId: ''
      },
      visible: false,
      orderGroupList:[]
    }
  },
  props: {
    orderIdList: {
      type: Array,
      default: ()=>([])
    }
  },
  created() {
    this.getOrderGroupMap()
  },
  methods: {
    async getOrderGroupMap() {
      try {
        const response = await this.$http.post('/order/getOrderGroup',{ orderIdList: this.orderIdList })
        console.log(response.data.data)
        if (response.data) {
          this.orderGroupList = response.data.data && response.data.data.length ? response.data.data: []
        } else {
          this.orderGroupList = []
        }
        if (this.orderGroupList.length > 0){
          this.visible = true;
        }else{
          this.$options.confirm([])
        }
      } catch (error) {
        console.error(error)
      }
    },
    async onSave(){
      let orderIdArr = this.orderGroupList.flatMap(item => item.orderIdList)
      await this.$http.post('/order/orderGroupAccept',{ orderIdList: orderIdArr })
      this.visible = false;
      this.$options.confirm([])
    },
    handleRemove() {
      let orderIdArr = this.orderGroupList.flatMap(item => item.orderIdList)
      this.visible = false;
      this.$options.cancel(orderIdArr)
    },
    handleClose() {
      this.visible = false;
    }
  }
}
</script>

<style scoped lang="less">
.orderGroupDialog{

  :deep(.el-dialog__body){
    padding: 5px 20px;
    line-height: 22px;
  }
  .dialog-footer{
    display: flex;
    align-items: end;
    justify-content: right;
  }
}
</style>
